import { Paper, Box, Typography, Chip, LinearProgress } from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  TrendingUpRounded,
  TrendingFlatRounded,
  TrendingDownRounded,
  AutoAwesomeRounded,
} from "@mui/icons-material";
import { palette, theme as colorTheme } from "../../../../Convoze.theme";

// const colorPalette = {
//   card: "#0f1014",
//   tile: "#111218",
//   border: "#1f1f23",
//   text: "#e5e7eb",
//   subtext: "#9aa0a6",
//   purple: "#7c3aed",
//   purpleLight: "#a78bfa",
//   green: "#10b981",
//   red: "#ef4444",
//   gold: "#fbbf24",
//   platinum: "#cfe8ff",
//   diamond: "#22d3ee",
// };



const Bar = styled(LinearProgress)(({ theme }) => ({
  height: 8,
  borderRadius: 8,
  backgroundColor: "#dad6d6ff",
  "& .MuiLinearProgress-bar": {
    borderRadius: 8,
    // background: `linear-gradient(90deg, #6366F1 0%, #9495dcff 50%, #a78bfa 100%)`,
    background: colorTheme('palette', 'primary').value
  },
}));



export default function MetricCard({
  icon,
  tier = "Gold",
  change = "+0%",
  title,
  value,
  targetText,
  leftHint = "87%",
  rightHint = "On track",
  progress = 87,
  highlight = "Crushing it!",
  highlightIcon = <AutoAwesomeRounded sx={{ fontSize: 16 }} />,
  borderAccent = "transparent",
  subTextColor,
}) {
  const isNeg = String(change).trim().startsWith("-");

  const getBadge = (rightHint) => {
    if (rightHint > 89) {
      return "💎Diamond";
    } else if (rightHint > 74) {
      return "🏆Platinum";
    } else if (rightHint > 59) {
      return "🥇Gold";
    } else {
      return "🥉 Bronze";
    }
  };
  const getRising = (rightHint) => {
    if (rightHint > 89) {
      return "Crushing it"
    } else if (rightHint > 74) {
      return "On Track"
    } else if (rightHint > 59) {
      return "Improving"
    } else {
      return "Time to improve"
    };

  };



  return (
    <Paper
      elevation={0}
      sx={{
        border: `1px solid ${
          // borderAccent !== "transparent" ? borderAccent : ` #C5EFD5`
          borderAccent !== "transparent" ? borderAccent : colorTheme('palette', 'primaryBg').value
          }`,
        borderRadius: 5,
        p: { xs: 1.75, sm: 2 },
        // boxShadow: "0 4px 12px rgba(99, 102, 241, 0.3)",
        // backgroundColor: borderAccent !== "transparent" ? "#FFFEFA" : "#FCFEFD",
        // backgroundColor: borderAccent !== "transparent"
        //   ? borderAccent
        //   : colorTheme('palette', 'primaryBg').value
      }}
    >
      {/* Header row */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 1.25,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              backdropFilter: "blur(3px)",
              width: 28,
              height: 28,
              borderRadius: "50%",
              display: "grid",
              placeItems: "center",
              backgroundColor: "#E3E6F9",
              //   backdropFilter: "blur(10px)",
              WebkitBackdropFilter: "blur(10px)",
              // color: "#6366F1",
              color : colorTheme('palette', 'primary').value
              // boxShadow: "0 4px 12px rgba(99, 102, 241, 0.3)",
            }}
          >
            {icon}
          </Box>
          <Chip
            size="small"
            label={getBadge(rightHint)}
            sx={{
              height: 22,
              // color: "#6366F1",
              color:colorTheme('palette', 'primary').value,
              // bgcolor: color,
              fontWeight: 500,
              backgroundColor: "#E3E6F9",
              "& .MuiChip-label": { px: 0.75, fontSize: "0.75rem" },
            }}
          />
        </Box>
        {/* <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}>
          {isNeg ? (
            <TrendingDownRounded sx={{ color: "red", fontSize: 18 }} />
          ) : (
            <TrendingUpRounded sx={{ color: "#10b981", fontSize: 18 }} />
          )}
          <Typography
            variant="caption"
            sx={{
              color: isNeg ? "red" : "#10b981",
              fontWeight: 700,
            }}
          >
            {change}
          </Typography>
        </Box> */}
      </Box>

      {/* Title */}
      <Typography
        variant="caption"
        sx={{
          textTransform: "uppercase",
          letterSpacing: 0.025,
          fontSize: "0.75rem",
          fontWeight: 500,
          lineHeight: "1rem",
          color: "#71717A",
        }}
      >
        {title}
      </Typography>

      {/* Value */}
      <Box
        sx={{
          display: "flex",
          alignItems: "baseline",
          gap: 0.75,
          mt: 1,
          mb: 1,
        }}
      >
        <Typography
          variant="h5"
          sx={{
            // background: `linear-gradient(90deg, #6366F1 0%, #9495dcff 50%, #a78bfa 100%)`,
            background :colorTheme('palette', 'primary').value,
            fontWeight: 700,
            lineHeight: 1,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            color: "transparent",
            fontSize: "1.25rem",
          }}
        >
          {value}
        </Typography>
        {targetText && (
          <Typography
            variant="body2"
            sx={{ color: "#9aa0a6", fontWeight: 600 }}
          >
            {targetText}
          </Typography>
        )}
      </Box>

      {/* Footer row with progress */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 0.75,
        }}
      >
        <Typography
          variant="caption"
          sx={{ fontWeight: 500, color: "#6e6e6eff" }}
        >
          {/* {leftHint} */}
        </Typography>
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 0.5,
            color: subTextColor,
          }}
        >
          <Typography
            variant="caption"
            sx={{ color: subTextColor, fontWeight: 700 }}
          >
            {getRising(rightHint)}
          </Typography>
          {highlightIcon}
        </Box>
      </Box>
      <Bar variant="determinate" value={progress} />
    </Paper>
  );
}
